// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__3GaJf","title":"card_title__1nLuG","inActive":"card_inActive__3MjIw"};